export default "__VITE_ASSET__DnNPXqcB__"